const SearchTypeSelect = ({ value, onChange, options, className = '' }) => (
  <select
    className={`w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-md text-sm focus:border-yellow-500 focus:outline-none ${className}`}
    onChange={(e) => onChange(e.target.value)}
    value={value}
  >
    {options.map((option) => (
      <option key={option.value || 'all'} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);

export default SearchTypeSelect;
